import access from "../access.json";

export default {
  status: "",
  email: localStorage.getItem("email") || "",
  token: localStorage.getItem("token") || "",
  token_type: localStorage.getItem("token_type") || "",
  role: localStorage.getItem("role"),
  access: access,
  assets: [],
  roles: [],
};
